import type { SvgIconType } from "../../helpers/SvgIcon";
import type { ActionMenuKind } from "./actionMenu.interface";

export const actionMenuKindIcons: Record<ActionMenuKind, SvgIconType> = {
  download: "DOWNLOAD",
  print: "PRINT",
  preview: "PREVIEW",
};
